export enum WalletFormFieldType {
  SELECT = 'select',
  TEXT = 'text',
  TEXTAREA = 'textarea',
  DISABLED = 'disabled',
  HIDDEN = 'hidden',
}

export const isWalletFormFieldDisabledType = (value: string) => {
  return WalletFormFieldType.DISABLED === value
}

export const isWalletFormFieldHiddenType = (value: string) => {
  return WalletFormFieldType.HIDDEN === value
}
